import React, { useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
export default () => {
  const [currentPage, setCurrentPage] = useState(1);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const localThumbnailImgurl = "uploads/news/thumbnail";
  const fetchNewsData = async ({ queryKey }) => {
    const [, page] = queryKey;
    const accessToken = localStorage.getItem("accessToken");
    const { data } = await axios.get(`${baseURL}/api/v2/news?page=${page}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data?.data;
  };
  const {
    data: newsData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["jobslisting", currentPage],
    queryFn: fetchNewsData,
    keepPreviousData: true,
  });

  const { has_more_pages, total_pages } = newsData || {};

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const handleNews = (id) => {
    navigate(`/news-details/${id}`);
  };
  return {
    // states
    isLoading,
    newsData,
    currentPage,
    setCurrentPage,
    total_pages,
    has_more_pages,

    // configs
    baseURL,
    localThumbnailImgurl,

    // handlers
    handleNews,
  };
};
